export default __webpack_public_path__ + "static/top-8-places-in-the-world-to-treat-yourself-449c3605eb152b2e203ca34e7e471e35.jpg";